import { SanityNode } from "../../config/build/models/node";
import siteConfig from "../../config/siteConfig";
import { RouteInfo, RouteInfoDictionary } from "../../models/shared/RouteInfo";

export type RouteInfoQueryResult = {
  blogLists: {
    nodes: SanityNode[];
  };
  pressReleaseLists: {
    nodes: SanityNode[];
  };
  courseLists: {
    nodes: Array<
      SanityNode & {
        courseCategory: {
          value: string;
        };
      }
    >;
  };
};

export const compareLanguages = (left: string | undefined, right: string | undefined) =>
  left?.toLowerCase() === right?.toLowerCase() ||
  (left?.toLowerCase() === siteConfig.baseLang && right === undefined) ||
  (left === undefined && right?.toLowerCase() === siteConfig.baseLang);

export function extractRouteInfoFromQueryResult(
  queryResult: RouteInfoQueryResult,
  lang: string
): RouteInfo {
  const pressReleaseListNode = queryResult.pressReleaseLists?.nodes.find(
    pressReleaseList => compareLanguages(pressReleaseList.i18nLang, lang)
  );

  const blogListNode = queryResult.blogLists?.nodes.find(blogList =>
    compareLanguages(blogList.i18nLang, lang)
  );

  const courseListNode = queryResult.courseLists?.nodes.find(courseList =>
    compareLanguages(courseList.i18nLang, lang)
  );

  return {
    blogList: blogListNode,
    pressReleaseList: pressReleaseListNode,
    courseList: courseListNode
  };
}

export function extractAllRouteInfosFromQueryResult(queryResult: RouteInfoQueryResult) {
  const blogLists = queryResult.blogLists?.nodes ?? [];
  const pressReleaseLists = queryResult.pressReleaseLists?.nodes ?? [];
  const courseLists = queryResult.courseLists?.nodes ?? [];

  const maxIndex = Math.max(
    blogLists.length,
    pressReleaseLists.length,
    courseLists.length
  );

  const routeInfos: RouteInfoDictionary = {};

  // TODO: Cleanup
  for (let i = 0; i < maxIndex; ++i) {
    if (i < blogLists.length) {
      const blogList = blogLists[i];
      let lang = blogList.i18nLang?.toLowerCase();

      if (lang === undefined) {
        lang = siteConfig.baseLang;
      }

      const pressReleaseList = pressReleaseLists.find(list =>
        compareLanguages(list.i18nLang, lang)
      );

      const courseList = courseLists.find(list => compareLanguages(list.i18nLang, lang));

      routeInfos[lang] = {
        blogList,
        pressReleaseList,
        courseList
      };
    } else if (i < pressReleaseLists.length) {
      const pressReleaseList = pressReleaseLists[i];
      let lang = pressReleaseList.i18nLang?.toLowerCase();

      if (lang === undefined) {
        lang = siteConfig.baseLang;
      }

      const blogList = blogLists.find(list => compareLanguages(list.i18nLang, lang));
      const courseList = courseLists.find(list => compareLanguages(list.i18nLang, lang));

      routeInfos[lang] = {
        blogList,
        pressReleaseList,
        courseList
      };
    } else if (i < courseLists.length) {
      const courseList = courseLists[i];
      let lang = courseList.i18nLang?.toLowerCase();

      if (lang === undefined) {
        lang = siteConfig.baseLang;
      }

      const blogList = blogLists.find(list => compareLanguages(list.i18nLang, lang));
      const pressReleaseList = pressReleaseLists.find(list =>
        compareLanguages(list.i18nLang, lang)
      );

      routeInfos[lang] = {
        blogList,
        pressReleaseList,
        courseList
      };
    }
  }

  return routeInfos;
}
